import { render, staticRenderFns } from "./HeadExemptedTotal.vue?vue&type=template&id=b1c20e0e"
import script from "./HeadExemptedTotal.vue?vue&type=script&lang=js"
export * from "./HeadExemptedTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports